import { render, staticRenderFns } from "./CircleItem.vue?vue&type=template&id=48e32295"
import script from "./CircleItem.vue?vue&type=script&lang=js"
export * from "./CircleItem.vue?vue&type=script&lang=js"
import style0 from "./CircleItem.vue?vue&type=style&index=0&id=48e32295&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports